export const InfoIcon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" className={className}>
    <path
      d="M7.30273 9.4V7M7.30273 4.6H7.30873M13.3027 7C13.3027 10.3137 10.6164 13 7.30273 13C3.98903 13 1.30273 10.3137 1.30273 7C1.30273 3.68629 3.98903 1 7.30273 1C10.6164 1 13.3027 3.68629 13.3027 7Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
